import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    price: yup.number().required('Campo obligatorio'),
    minAgendas: yup.number().required('Campo obligatorio'),
    maxAgendas: yup.number().required('Campo obligatorio'),
  })
  .required()
